import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SectionWrapper } from '../ui/SectionWrapper';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <SectionWrapper background="white" data-id="element-145">
      <div ref={ref} className="grid md:grid-cols-2 gap-12 items-center" data-id="element-146">
        {/* Content */}
        <div className="order-2 md:order-1" data-id="element-147">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-6" data-id="element-148">
            Cuando las noches mojadas empiezan a afectar a toda la familia
          </h2>

          <motion.div initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {}} transition={{
          delay: 0.2
        }} className="space-y-4 text-navy/70 text-lg leading-relaxed mb-8" data-id="element-149">
            <p data-id="element-150">
              Sabemos lo que se siente. Las noches interrumpidas, el cansancio
              acumulado, la preocupación silenciosa de no saber si estás
              haciendo lo correcto.
            </p>
            <p data-id="element-151">
              Quizás has probado diferentes cosas sin resultados claros. Quizás
              te preguntas si es normal, si deberías esperar más, o si hay algo
              que puedas hacer sin presionar a tu hijo.
            </p>
            <p data-id="element-152">
              Ese desgaste emocional es real. Y merece ser atendido con calma y
              con un plan que funcione para toda la familia.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.4
        }} className="bg-cream border-l-4 border-soft-blue p-6 rounded-r-xl" data-id="element-153">
            <p className="text-navy font-medium text-lg italic" data-id="element-154">
              "No estás sola. Este proceso es más común de lo que imaginas."
            </p>
          </motion.div>
        </div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={isInView ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        duration: 0.6
      }} className="order-1 md:order-2" data-id="element-155">
          <img src="https://cdn.magicpatterns.com/uploads/cKxKiUtc4vKccJJuafn9En/3._img_pipi_landing.png" alt="Madre e hijo revisando juntos una lista de seguimiento en la habitación" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-156" />
        </motion.div>
      </div>
    </SectionWrapper>;
}